export const ACK_REQUIRED_ERROR_MESSAGE = "Acknowledgement required"

export const TEXT_FONT_SIZE = "0.875rem"
